import React from "react";
import { Route, Switch } from "react-router-dom";
import { useLenis } from "./hooks/useLenis";
import Navbar from "./sections/Navbar";
import FooterPremium from "./sections/FooterPremium";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ClientStoriesPage from "./pages/ClientStoriesPage";
import ContactPage from "./pages/ContactPage";
import "./index.css";

const App = () => {
  useLenis();

  return (
    <div className="bg-navy">
      <Navbar />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/about" component={AboutPage} />
        <Route path="/projects" component={ProjectsPage} />
        <Route path="/client-stories" component={ClientStoriesPage} />
        <Route path="/contact" component={ContactPage} />
      </Switch>
      <FooterPremium />
    </div>
  );
};

export default App;
